import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: '24px'
});

const StyledIcon = styled(Box)(({ theme }) => ({
  marginBottom: '16px',
  color: theme.palette.text.disabled
}));

const StyledMessageHead = styled(Typography)({
  fontSize: '1.2rem',
  fontWeight: 500,
  marginBottom: '8px'
});

const StyledMessageBody = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: 'center'
}));

function CommonMessages({ icon, messageHead, messageBody, placeOrderBtnEnabled = false }) {
  return (
    <StyledRoot>
      <StyledIcon>
        {icon}
      </StyledIcon>
      <StyledMessageHead variant="h6">
        {messageHead}
      </StyledMessageHead>
      <StyledMessageBody variant="body1">
        {messageBody}
      </StyledMessageBody>
    </StyledRoot>
  );
}

export default CommonMessages; 